export const extrapayFlowDictPT = {
  extrapayFlowTitle: "Extrapay",
  extrapayFlowProgram: "EXTRAPAY | PROGRAMA DE PONTOS",
  extrapayFlowBannerTitle: "Suas compras abrem novas possibilidades.",
  extrapayFlowBannerSubtitle:
    "Acumule pontos nas compras. A cada 10 compras aprovadas, seus pontos são convertidos em EXC.",
  extrapayFlowOpen: "Acessar Extrapay",
  extrapayFlowCyclePoints: "Pontos do ciclo",
  extrapayFlowPointsUnit: "pontos",
  extrapayFlowPointsAccumulated: "Acumulados nas compras deste ciclo",
  extrapayFlowOrdersProgress: "{current} de {total} compras",
  extrapayFlowCycleLabel: "Ciclo {cycle}",
  extrapayFlowOnePurchaseLeft: "Falta 1 compra para concluir o ciclo.",
  extrapayFlowPurchasesLeft: "Faltam {count} compras para concluir o ciclo.",
  extrapayFlowCycleComplete: "Ciclo completo. A conversão em EXC é feita automaticamente.",
  extrapayFlowAccumulatedRate: "Taxa de conversão acumulada",
  extrapayFlowRateContinues: "Continua acumulada nos próximos ciclos",
  extrapayFlowPlatformBalance: "SALDO EXC NA PLATAFORMA",
  extrapayFlowAvailableExternal: "Disponível para envio à sua carteira externa.",
  extrapayFlowRequestWithdraw: "Solicitar saque",
  extrapayFlowLoadError: "Não foi possível carregar o Extrapay.",
  extrapayFlowRetry: "Tentar novamente",
  extrapayFlowPageSubtitle: "Acompanhe seus pontos, EXC e solicitações de saque.",
  extrapayFlowPointsTitle: "PONTOS EXTRAPAY",
  extrapayFlowCanRequest: "Você pode solicitar {amount} EXC para sua carteira externa.",
  extrapayFlowRateNotice:
    "Sua taxa de conversão acumulada é {rate}. Ela continua acumulada nos próximos ciclos.",
  extrapayFlowUnderstandRate: "Entender a taxa",
  extrapayFlowTabPoints: "Pontos",
  extrapayFlowTabExc: "EXC",
  extrapayFlowTabWithdrawals: "Saques",
  extrapayFlowOrigin: "Origem",
  extrapayFlowDate: "Data",
  extrapayFlowCycle: "Ciclo",
  extrapayFlowPoints: "Pontos",
  extrapayFlowViewDetails: "Ver detalhes",
  extrapayFlowPurchaseOrigin: "Compra #{id}",
  extrapayFlowMovement: "Movimentação",
  extrapayFlowRequest: "Solicitação",
  extrapayFlowSituation: "Situação",
  extrapayFlowPointsEmpty: "Nenhuma compra aprovada encontrada.",
  extrapayFlowExcEmpty: "As conversões de pontos em EXC aparecerão aqui quando um ciclo for concluído.",
  extrapayFlowWithdrawalsEmpty: "Você ainda não solicitou saques de EXC.",
  extrapayFlowPreviousCyclesEmpty: "Os ciclos já convertidos aparecerão aqui.",
  extrapayFlowStatusRequested: "Solicitado",
  extrapayFlowStatusAwaiting: "Aguardando transferência",
  extrapayFlowStatusConfirmed: "Confirmado",
  extrapayFlowStatusConverted: "Convertido",
  extrapayFlowStatusNotConverted: "Não convertido",
  extrapayFlowStatusInProgress: "Em andamento",
  extrapayFlowStatusAccumulating: "Acumulando compras",
  extrapayFlowKnowTitle: "Conheça o Extrapay",
  extrapayFlowKnowSubtitle: "Entenda como suas compras geram pontos e saldo EXC na plataforma.",
  extrapayFlowKnowProgram: "PROGRAMA DE PONTOS",
  extrapayFlowKnowHeading: "Como funciona o Extrapay",
  extrapayFlowKnowIntro:
    "O Extrapay registra pontos nas compras com pagamento aprovado. A cada 10 compras, esses pontos são convertidos em Extracoin (EXC), que fica no seu saldo dentro da plataforma.",
  extrapayFlowStepPurchase: "COMPRA APROVADA",
  extrapayFlowStepPurchaseNote: "após descontos · sem frete",
  extrapayFlowStepPurchasePoints: "+50 pontos",
  extrapayFlowStep1Label: "ETAPA 1 · PONTOS",
  extrapayFlowStep1Title: "Os pontos entram após o pagamento",
  extrapayFlowStep1Body:
    "Você recebe pontos correspondentes a 50% do valor da compra após descontos. Por exemplo, uma compra de € 100, sem frete, gera 50 pontos.",
  extrapayFlowStepCycle: "SEU CICLO DE COMPRAS",
  extrapayFlowStepCycleDone: "10 compras aprovadas",
  extrapayFlowStep2Label: "ETAPA 2 · CICLO",
  extrapayFlowStep2Title: "Cada ciclo reúne 10 compras",
  extrapayFlowStep2Body:
    "Cada compra com pagamento aprovado conta como uma etapa. No Extrapay, você consulta os pontos acumulados e quantas compras faltam para completar o ciclo.",
  extrapayFlowStepBalance: "SALDO NA PLATAFORMA",
  extrapayFlowStepBalanceNote: "Crédito após a conversão",
  extrapayFlowStep3Label: "ETAPA 3 · CONVERSÃO",
  extrapayFlowStep3Title: "Os pontos são convertidos em EXC",
  extrapayFlowStep3Body:
    "Na décima compra, o sistema multiplica os pontos do ciclo pela sua taxa de conversão acumulada. O resultado é creditado em EXC no saldo da plataforma.",
  extrapayFlowAfterConversionTitle: "O que muda após a conversão",
  extrapayFlowAfterConversionBody:
    "Quando o crédito em EXC é concluído, os pontos do ciclo e o contador de compras voltam a zero. A taxa de conversão continua acumulada e será usada nos próximos ciclos.",
  extrapayFlowBalanceSection: "SALDO E SAQUE",
  extrapayFlowWhereTitle: "Onde ficam os EXC recebidos",
  extrapayFlowWhereBody:
    "EXC é a sigla de Extracoin. Após a conversão, o valor fica registrado na plataforma. Para recebê-lo em uma carteira cripto externa, você precisa solicitar um saque.",
  extrapayFlowOnPlatform: "Na plataforma",
  extrapayFlowYourExcBalance: "Seu saldo EXC",
  extrapayFlowOnExternalWallet: "Na carteira externa",
  extrapayFlowSameExcAmount: "A mesma quantidade de EXC",
  extrapayFlowWithdrawPath:
    "Ao solicitar o saque, informe o endereço da carteira e o valor. O valor é descontado do saldo na plataforma na confirmação. Depois, a equipe envia a mesma quantidade de EXC para o endereço informado.",
  extrapayFlowFaqTitle: "Detalhes sobre o cálculo e o saque",
  extrapayFlowFaqSubtitle: "Selecione uma pergunta para consultar a explicação.",
  extrapayFlowFaqWhen: "Quanto EXC vou receber?",
  extrapayFlowFaqWhenAnswer:
    "A quantidade de EXC depende de dois valores: os pontos acumulados no ciclo e a taxa de conversão acumulada. Por isso, ciclos diferentes podem gerar quantidades diferentes de EXC.",
  extrapayFlowFaqWhenExampleLabel: "UM EXEMPLO",
  extrapayFlowFaqWhenExampleFormula: "500 pontos × 0,00070 de taxa = 0,35 EXC",
  extrapayFlowFaqWhenExampleNote:
    "Neste exemplo, são 10 compras de € 100 após descontos, sem frete, usando 18 Extracredits em cada compra e começando com a taxa zerada. Outras compras e taxas podem gerar valores diferentes.",
  extrapayFlowFaqRate: "Como a minha taxa de conversão aumenta?",
  extrapayFlowFaqRateAnswer:
    "Cada compra soma 3 pontos para o cálculo da taxa quando não há frete, ou 6 quando há frete. A quantidade de Extracredit utilizada também é somada.",
  extrapayFlowFaqRateAnswer2:
    "Essa pontuação serve apenas para calcular a taxa; ela não entra no saldo de pontos do ciclo. A taxa é o número usado para converter os pontos em EXC, não uma tarifa cobrada. O sistema calcula e apresenta esse número no Extrapay.",
  extrapayFlowFaqRateCalcTitle: "Cálculo completo",
  extrapayFlowFaqRateCalcLine1: "Taxa acumulada = pontuação acumulada para a taxa ÷ 3 × 0,00001.",
  extrapayFlowFaqRateCalcLine2:
    "No exemplo: 10 × (3 + 18) = 210. A taxa é 210 ÷ 3 × 0,00001 = 0,00070. Depois, 500 pontos × 0,00070 = 0,35 EXC no saldo da plataforma.",
  extrapayFlowFaqRateCalcLine3:
    "Os pontos do ciclo correspondem a 50% do valor da compra após descontos. A taxa não tem limite ou expiração definidos.",
  extrapayFlowFaqWallet: "Preciso ter uma carteira cripto para começar?",
  extrapayFlowFaqWalletAnswer:
    "Não. Seus EXC ficam no saldo da plataforma. Você só precisa informar o endereço de uma carteira compatível com a rede Extracoin quando quiser solicitar um saque.",
  extrapayFlowFaqWalletAnswer2:
    "O crédito no Extrapay não é uma transferência para a carteira externa. Essa transferência acontece depois da solicitação e é feita pela equipe.",
  extrapayFlowKnowCtaTitle: "Consulte seu ciclo e seu saldo",
  extrapayFlowKnowCtaBody:
    "No Extrapay, você encontra os pontos acumulados, o número de compras e os EXC disponíveis.",
  extrapayFlowKnowCta: "Consultar meu Extrapay",
  extrapayFlowWithdrawTitle: "Saque de tokens",
  extrapayFlowWithdrawSubtitle: "Consulte o saldo e acompanhe suas solicitações.",
  extrapayFlowWalletAddress: "Endereço da carteira Extracoin",
  extrapayFlowWalletAddressHint: "Copie o endereço de recebimento da sua carteira na rede Extracoin.",
  extrapayFlowWithdrawAmount: "Valor do saque em EXC",
  extrapayFlowAvailableBalance: "Saldo disponível na plataforma: {amount} EXC.",
  extrapayFlowReviewWithdraw: "Revisar saque",
  extrapayFlowHowYouReceive: "Como você receberá",
  extrapayFlowHowYouReceiveBody:
    "O Extracoin será enviado para a carteira que você informar. Confira se o endereço pertence a você e está na rede Extracoin.",
  extrapayFlowHowYouReceiveDebit:
    "Ao confirmar, o valor será descontado do seu saldo EXC na plataforma. A equipe fará a transferência depois.",
  extrapayFlowHowYouReceivePartial:
    "Você pode solicitar uma parte do saldo e acompanhar cada pedido em “Meus saques”.",
  extrapayFlowDebitNotice: "O valor solicitado será descontado do seu saldo EXC na plataforma.",
  extrapayFlowAddressRequired: "Informe o endereço da carteira.",
  extrapayFlowAmountRequired: "Informe um valor maior que zero.",
  extrapayFlowAmountAboveBalance: "O valor não pode ser maior que o saldo disponível.",
  extrapayFlowConfirmTitle: "Confira seu saque",
  extrapayFlowConfirmSubtitle: "Revise o endereço e o valor antes de confirmar.",
  extrapayFlowYouReceive: "Você receberá",
  extrapayFlowNetwork: "Rede",
  extrapayFlowNetworkName: "Extracoin",
  extrapayFlowDestination: "Endereço de destino",
  extrapayFlowPlatformDebit: "Desconto do saldo na plataforma",
  extrapayFlowBalanceAfter: "Saldo na plataforma após a solicitação",
  extrapayFlowConfirmCheck: "Conferi o endereço da minha carteira e o valor do saque.",
  extrapayFlowConfirmNote:
    "Ao confirmar, o valor será descontado do seu saldo EXC na plataforma. O envio para a carteira externa será feito depois.",
  extrapayFlowConfirmAction: "Confirmar saque",
  extrapayFlowEditValues: "Editar endereço ou valor",
  extrapayFlowSuccessTitle: "Solicitação registrada",
  extrapayFlowSuccessSubtitle: "O saldo foi atualizado. Acompanhe a transferência pelo histórico.",
  extrapayFlowAvailableBalanceLabel: "Saldo disponível",
  extrapayFlowAddress: "Endereço",
  extrapayFlowSuccessNote:
    "A equipe fará a transferência para sua carteira. Acompanhe a atualização em “Meus saques”.",
  extrapayFlowTrackWithdraw: "Acompanhar saque",
  extrapayFlowMyWithdrawals: "Meus saques",
  extrapayFlowWithdrawalsCrumb: "Saques",
  extrapayFlowDetailsCrumb: "Detalhes",
  extrapayFlowCycleCrumb: "Detalhes de ciclo",
  extrapayFlowWithdrawDetailsTitle: "Detalhes do saque {id}",
  extrapayFlowWithdrawDetailsSubtitle:
    "Seu pedido foi registrado e o valor foi descontado do saldo EXC na plataforma.",
  extrapayFlowRequestDate: "Data da solicitação",
  extrapayFlowUser: "Usuário",
  extrapayFlowWithdrawValue: "Valor do saque",
  extrapayFlowInformedAddress: "Endereço informado",
  extrapayFlowBackToWithdrawals: "Voltar aos saques",
  extrapayFlowWithdrawNotFound: "Não foi possível encontrar esta solicitação.",
  extrapayFlowCycleSubtitle: "A cada 10 compras aprovadas, seus pontos são convertidos em EXC.",
  extrapayFlowPurchases: "Compras",
  extrapayFlowAccumulatedFee: "Taxa acumulada",
  extrapayFlowPointsToConvert: "Pontos a converter",
  extrapayFlowCyclePointsTitle: "Pontos do ciclo",
  extrapayFlowViewPoints: "Ver pontos",
  extrapayFlowPreviousCycles: "Ciclos anteriores e operações",
  extrapayFlowOperation: "Operação",
  extrapayFlowBackToExtrapay: "Voltar ao Extrapay",
  extrapayFlowConversionTitle: "Conversão do Ciclo {cycle}",
  extrapayFlowConversionFallback: "Conversão",
  extrapayFlowUnavailable: "—",
  extrapayFlowBasicData: "Dados básicos",
  extrapayFlowReference: "Referência",
  extrapayFlowQuantity: "Quantidade",
  extrapayFlowViewFullConversion: "Ver conversão completa",
  extrapayFlowExcAmount: "{amount} EXC",
  extrapayFlowSignedExc: "+{amount} EXC",
  extrapayFlowSignedPoints: "+{amount}",
  extrapayFlowPurchasePointsTitle: "Pontos da compra #{id}",
  extrapayFlowPurchasePointsSubtitle: "Veja de onde vieram os pontos deste lançamento.",
  extrapayFlowAmountAfterDiscount: "Valor após desconto",
  extrapayFlowPointsPercent: "Percentual em pontos",
  extrapayFlowPointsPercentValue: "50%",
  extrapayFlowPointsReceived: "Pontos recebidos",
  extrapayFlowPurchasePointsNote:
    "Esses pontos ficam no saldo do ciclo até a conversão após 10 compras.",
  extrapayFlowOtpInvalid:
    "Código de verificação inválido ou expirado. Confira o e-mail ou solicite um novo código.",
};
